<script setup lang="ts">
interface Props {
    type: 'racquet' | 'shoes';
    id: string;
    amount?: number;
}
defineProps<Props>();
</script>

<template>
    <div class="relative w-16 h-16" :style="`background-image: url(/images/internalEquipment/${type}/${id}.png)`">
        <div class="absolute right-1 bottom-0 text-right text-zinc-100 text-xs">{{ amount }}</div>
    </div>
</template>
